import React from "react";
import { Col, Container, Form, Row } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, ErrorMessage } from "formik";

const Contact = () => {
  const initialValues = {
    name: "",
    email: "",
    subject: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
  });

  const handleSubmit = (values) => {
    const mailToLink = `mailto:admin@codeplayers.in?subject=${encodeURIComponent(
      values.subject
    )}&body=${encodeURIComponent(
      `To Codeplayers,

I am reaching out with the following details:

Name: ${values.name}
Email: ${values.email}

Message: 
${values.message}

Thank you,
${values.name}`
    )}`;

    window.open(mailToLink, "_self");
  };

  return (
    <React.Fragment>
      <section className="section" id="contact">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center mb-5">
                <h3 className="mb-3 fw-semibold">Get In Touch</h3>
                <p className="text-muted mb-4 ff-secondary">
                  We thrive when coming up with innovative ideas but also
                  understand that a smart concept should be supported with
                  measurable results.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="gy-4 d-flex align-items-stretch">
            <Col lg={4} className="d-flex flex-column">
              <div className="flex-grow-1">
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Head Office:
                  </h5>
                  <div className="ff-secondary">
                    <strong>CODEPLAYERS BUSINESS SYSTEM PRIVATE LIMITED</strong> <br />
                    C 24-25, SECTOR – 5, DEVENDRA NAGAR RAIPUR (C.G) - 492001
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Regional Office:
                  </h5>
                  <div className="ff-secondary">
                    <strong>CODEPLAYERS BUSINESS SYSTEM PRIVATE LIMITED</strong> <br />
                    191/2 Nand Bhawan, Gandhi Ganj, Raigarh, Chhattisgarh 496001
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Contact Number:
                  </h5>
                  <div className="ff-secondary fw-semibold">
                  <a href='tel:+91 75818 75000'>+91 75818 75000</a><br />
                  <a href='tel:+91 75828 75000'>+91 75828 75000</a>
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Reachable Hours:
                  </h5>
                  <div className="ff-secondary fw-semibold">
                    11:00AM to 5:00PM
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Email us at:
                  </h5>
                  <div className="ff-secondary fw-semibold">
                    <a href="mailto:admin@codeplayers.in">admin@codeplayers.in</a>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={8} className="d-flex flex-column">
              <div className="flex-grow-1">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col lg={6}>
                          <div className="mb-4">
                            <label
                              htmlFor="name"
                              className="form-label fs-13"
                            >
                              Name
                            </label>
                            <Field
                              name="name"
                              id="name"
                              type="text"
                              className="form-control bg-light border-light"
                              placeholder="Your name*"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="text-danger mt-1"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-4">
                            <label
                              htmlFor="email"
                              className="form-label fs-13"
                            >
                              Email
                            </label>
                            <Field
                              name="email"
                              id="email"
                              type="email"
                              className="form-control bg-light border-light"
                              placeholder="Your email*"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger mt-1"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <div className="mb-4">
                            <label
                              htmlFor="subject"
                              className="form-label fs-13"
                            >
                              Subject
                            </label>
                            <Field
                              type="text"
                              className="form-control bg-light border-light"
                              id="subject"
                              name="subject"
                              placeholder="Your Subject.."
                            />
                            <ErrorMessage
                              name="subject"
                              component="div"
                              className="text-danger mt-1"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <div className="mb-3">
                            <label
                              htmlFor="message"
                              className="form-label fs-13"
                            >
                              Message
                            </label>
                            <Field
                              as="textarea"
                              name="message"
                              id="message"
                              rows="3"
                              className="form-control bg-light border-light"
                              placeholder="Your message..."
                            />
                            <ErrorMessage
                              name="message"
                              component="div"
                              className="text-danger mt-1"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} className="text-end">
                          <button
                            type="submit"
                            id="submit"
                            className="submitBnt btn btn-primary"
                          >
                            Send Message
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Contact;
